import { render, staticRenderFns } from "./feature-type.component.vue?vue&type=template&id=4ba9d13a&scoped=true&"
import script from "./feature-type.component.vue?vue&type=script&lang=js&"
export * from "./feature-type.component.vue?vue&type=script&lang=js&"
import style0 from "./feature-type.component.vue?vue&type=style&index=0&id=4ba9d13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9d13a",
  null
  
)

export default component.exports